import script from "./PolicyView.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__